import { createContext, useContext, useReducer } from "react";
import { cartService } from "../services/cartService";

const CartContext = createContext();

function cartReducer(state, action) {
  let newItems;
  switch (action.type) {

    case "SET":
      return { ...state, items: action.items };

    case "ADD":
      newItems = cartService.add(state.items, action.product, action.quantity);
      cartService.save(newItems);
      return { ...state, items: newItems };

    case "UPDATE_QTY":
      newItems = cartService.updateQuantity(state.items, action.productId, action.quantity);
      cartService.save(newItems);
      return { ...state, items: newItems };

    case "REMOVE":
      newItems = cartService.remove(state.items, action.productId);
      cartService.save(newItems);
      return { ...state, items: newItems };

    case "CLEAR":
      cartService.clear();
      return { ...state, items: [] };

    default: return state;
  }
}

export function CartProvider({ children }) {

  const [state, dispatch] = useReducer(cartReducer, {
    items: cartService.load(),
  });


  // ── Actions ───────────────────────────────────────────
  const addToCart = (product, quantity = 1) =>
    dispatch({ type: "ADD", product, quantity });

  const updateQuantity = (productId, quantity) =>
    dispatch({ type: "UPDATE_QTY", productId, quantity });

  const removeFromCart = (productId) =>
    dispatch({ type: "REMOVE", productId });

  const clearCart = async () => {
    dispatch({ type: "CLEAR" });
  };

  return (
    <CartContext.Provider value={{
      items:           state.items,
      total:           cartService.getTotal(state.items),
      count:           cartService.getCount(state.items),
      addToCart,
      updateQuantity,
      removeFromCart,
      clearCart,
      isInCart:        (id) => state.items.some(i => i.productId === id),
      getItemQuantity: (id) => state.items.find(i => i.productId === id)?.quantity || 0,
    }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);